//@ts-nocheck
import vuetify from '@/plugins/vuetify'
import './scss/vuetifySettings.scss'

import 'vuetify/_styles.scss'
import './scss/main.css'
import './scss/main.scss'

import '/node_modules/@rfc/rfc-components-library/dist/scss/main.css'
// Style & Icons
import '@mdi/font/css/materialdesignicons.css'
import 'highlight.js/styles/monokai.css'

import 'splitpanes/dist/splitpanes.css'

import * as Vue from 'vue'
import App from './App.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

import * as Sentry from '@sentry/vue'

import { interceptorsSetup } from '@rfc/rfc-components-library/helpers'
import i18n from './locales/i18n'
import router from './router'
import setupStore from './store'

const getEnv = () => {
    if (window.location.host.includes('localhost')) return 'local'
    if (window.location.host.match(/^dev/)) return 'development'
    return import.meta?.env?.MODE ?? 'production'
}

const app = Vue.createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fab)
library.add(fas)
library.add(far)

app.use(vuetify)

app.use(router)

const store = setupStore(router)

app.use(store)
app.use(i18n)
interceptorsSetup(store, router, i18n as any)

if (getEnv() !== 'local')
    Sentry.init({
        app,
        dsn: 'https://e0f936b6a9d74ee36d86e542acd96a41@sentry.rfconception.com/5',
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                blockAllMedia: false
            })
        ],

        environment: getEnv(),

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
        tracePropagationTargets: [
            /^localhost/,
            /^https:\/\/dev\.hub\.v2\.urtime\.net/,
            /^https:\/\/hub\.urtime\.net/
        ],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0

        // Other config
    })
app.mount('#app')
